"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

// Main business address of Novivia / Auctionex HQ
// AE_BUSINESS_CONTACT
exports.default = {
    address: ["1982 Beaubien E"],
    city: "Montréal",
    region: "Québec",
    postalCode: "H2G 1M1",
    country: "Canada",
    telephone: "+1-514-700-2050",
    tollFree: "1-855-465-0525"
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/configurations/lib/common/AE_BUSINESS_CONTACT.js
// module id = 56
// module chunks = 9 10 11 12 13 14 15 18 19 20 21 22 23 24 25 26 27 28 29 30 33 34 35 38 39 40 41 42 43 45 46 47 48 49 50 51 54